import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const RightArrowIcon = ({ size }: IconSvgProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 11 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.40698 0.5L6.32733 1.7021L8.07756 3.6497H0.762206C0.340929 3.6497 -0.000976562 4.03038 -0.000976562 4.49943C-0.000976562 4.96849 0.340929 5.34917 0.762206 5.34917H8.07756L6.32733 7.2979L7.40698 8.5L10.999 4.49943L7.40698 0.5Z"
                fill="#0065FF"
            />
        </svg>
    );
};
